import React from "react";
import "./Footer.css"; // Import the CSS file for styling
import LogoLight from "../../../images/logo/logo-light.svg";
import linkedIn from "./images/linkedin.svg";
import phoneImg from "./images/phone.svg";
import emailImg from "./images/email.svg";
// import LogoLight from "../../images/logo/logo-light.svg";

export default function ProducktFooter() {
	return (
		<footer className="footer">
			<div className="container flex-column">
				<h2 className="footer-heading text-white">Jetzt Kontakt aufnehmen</h2>
				<div className="contact-buttons">
					<a href="tel:+49213239123" className="contact-button">
						<img src={phoneImg} alt="" className="footer-logo-light" /> +49
						213239123
					</a>
					<a href="mailto:info@feingeist.com" className="contact-button">
						<img src={emailImg} alt="" className="footer-logo-light" /> E-Mail
						schreiben
					</a>
				</div>
				<hr className="w-100" />
				<div className="footer-content">
					<div className="footer-section flex-column">
						<div className="footer-section-hd">
							<img src={LogoLight} alt="" className="footer-logo-light" />
						</div>
						<div className="footer-section-body">
							<p>Feingeist GmbH</p>
							<p>Quartier Potsdamer Platz</p>
							<p>Linkstraße 2 | Level 8</p>
							<p>10785 Berlin</p>
						</div>
					</div>
					<div className="footer-section">
						<div className="footer-section-hd">
							<span>Leistungen</span>
						</div>

						<div className="footer-section-body">
							<p>Prozesse digitalisieren</p>
							<p>Unternehmenskauf und -verkauf</p>
							<p>ESG konform umsetzen</p>
							<p>Strategieberatung</p>
						</div>
					</div>
					<div className="footer-section">
						<div className="footer-section-hd">
							<span>Unternehmen</span>
						</div>

						<div className="footer-section-body">
							<p>Über uns</p>
							<p>Karriere</p>
						</div>
					</div>
					<div className="footer-section">
						<div className="footer-section-hd">
							<span>Legal</span>
						</div>

						<div className="footer-section-body">
							<p>Datenschutz</p>
							<p>Impressum</p>
							<p>Cookie-Richtlinien</p>
						</div>
					</div>
				</div>

				<hr className="w-100" />
				<div className="footer-bottom">
					<p>&copy; Feingeist GmbH 2024</p>
					<a href="https://www.linkedin.com" className="social-link px-2">
						Folgen Sie uns:{" "}
						<a
							className="px-2"
							href="https://linkedin.com/company/feingeist-beratung"
						>
							<img src={linkedIn} />
						</a>
					</a>
				</div>
			</div>
		</footer>
	);
}
